// Default website feature wording for Wedding/Event packages, in both languages.
// The catalog form pre-fills the English/Arabic feature textareas from the enabled
// capability switches using these lines; the SuperAdmin can then edit them freely.
// Kept as fixed en/ar text (not i18n keys) because the output is public-website
// copy in a specific language, independent of the admin UI's current language.
const FEATURE_LINES = [
  { key: "hasWhatsAppSupport", en: "WhatsApp delivery & support", ar: "إرسال ودعم عبر الواتساب" },
  { key: "hasSmsSupport", en: "SMS delivery", ar: "إرسال رسائل نصية" },
  { key: "customizationOptions", en: "Design customization", ar: "خيارات تخصيص التصميم" },
  { key: "hasQrCheckIn", en: "QR code check-in", ar: "تسجيل الحضور عبر رمز QR" },
  { key: "hasDigitalPassSupport", en: "Apple & Google Wallet digital passes", ar: "بطاقات رقمية في محافظ أبل وقوقل" },
  { key: "hasLiveDashboard", en: "Live dashboard", ar: "لوحة متابعة مباشرة" },
  { key: "hasPostEventAnalytics", en: "Post-event analytics", ar: "تحليلات ما بعد الفعالية" },
  { key: "hasVipSupport", en: "VIP registrations", ar: "تسجيل كبار الشخصيات (VIP)" },
  { key: "hasSpeakerSupport", en: "Speaker management", ar: "إدارة المتحدثين" },
  { key: "hasExhibitorSupport", en: "Exhibitor management", ar: "إدارة العارضين" },
  { key: "hasExportSupport", en: "Attendee CSV export", ar: "تصدير بيانات الحضور (CSV)" },
];

export const FEATURE_SWITCH_KEYS = FEATURE_LINES.map((f) => f.key);

// values: the package form's current values (capability switches as booleans).
// Returns newline-joined text for the English and Arabic textareas.
export const buildDefaultFeatureText = (values = {}) => {
  const enabled = FEATURE_LINES.filter((f) => values[f.key]);
  return {
    featuresEn: enabled.map((f) => f.en).join("\n"),
    featuresAr: enabled.map((f) => f.ar).join("\n"),
  };
};

export const splitFeatureLines = (text) =>
  typeof text === "string" ? text.split("\n").map((s) => s.trim()).filter(Boolean) : [];
